const questions = [
  {
    id: 1,
    title: 'Will I lose my photos if I delete my account?',
    description:
      'No, every photo you have will be stored in our database, even if you delete the account there is always the possibility of restore the account.',
  },
  {
    id: 2,
    title: 'What is the limit size of the photos?',
    description: 'Right now, there is no limits of the size of the photos.',
  },
  {
    id: 3,
    title: 'What happens when if I dont have any more space?',
    description: 'There are 3 plans right now so you can max your space.',
  },
  {
    id: 4,
    title: 'Can I upload more than one photo at once?',
    description:
      'Yes, you can upload multiple photos at once, if you dont have enougth space it will ask you if you want to upgrade your plan.',
  },
  {
    id: 5,
    title: 'What happens if I delete a photo, can I undo it?',
    description:
      'Yes, it will go to a folder of deleted photos, it will empty automaticly after 30 days, so you have 30 days to restore the deleted photo.',
  },
];

export default questions;
